import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useEmbeddedModeStore } from '@/store/EmbeddedModeStore';

/**
 * Returns whether Raptor chrome (sidebar / header / FAB) should be hidden for an ERP embed session.
 * Syncs `?embed=1|true` / `?embed=0|false` into localStorage so in-app navigations stay chrome-free.
 */
export function useEmbeddedMode(): boolean {
  const location = useLocation();
  const isEmbedded = useEmbeddedModeStore((s) => s.isEmbedded);
  const syncFromSearch = useEmbeddedModeStore((s) => s.syncFromSearch);

  useEffect(() => {
    syncFromSearch(location.search);
  }, [location.search, syncFromSearch]);

  return isEmbedded;
}
